/**
 * Returns Set of duplicate indices - O(n) algorithm
 * Used for poll option validation in both mobile and web
 */
export const getDuplicateIndices = (options: { text: string }[]): Set<number> => {
  const textToFirstIndex = new Map<string, number>()
  const duplicateIndices = new Set<number>()

  options.forEach((option, index) => {
    const text = option.text.trim()
    if (!text) return

    if (textToFirstIndex.has(text)) {
      duplicateIndices.add(textToFirstIndex.get(text)!)
      duplicateIndices.add(index)
    } else {
      textToFirstIndex.set(text, index)
    }
  })

  return duplicateIndices
}
